import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { palette, theme as colorTheme} from "../../../../Convoze.theme";







function StatusFilter({ value, onChange }) {

  const primary = colorTheme('palette', 'primary').value;


  return (
    <FormControl
      size="small"
      sx={{
        minWidth: { xs: "100%", sm: 120 },
        width: { xs: "100%", sm: "auto" },
        "& .MuiOutlinedInput-root": {
          "&:hover fieldset": { borderColor: primary },
          "&.Mui-focused fieldset": { borderColor: primary },
          "& .MuiInputBase-input": { fontSize: 14 },
        },
        "& .MuiInputLabel-root": {
          color: "text.secondary", 
          fontSize: 14,
          "&.Mui-focused": {
            // color: "#6366F1", 
            color : primary
          },
        },
      }}
    >
      <InputLabel>All Status</InputLabel>
      <Select
        label="All Status"
        defaultValue="All"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="All">All Status</MenuItem>
        <MenuItem value="Active">Active</MenuItem>
        <MenuItem value="InActive">InActive</MenuItem>
      </Select>
    </FormControl>
  );
}

export default StatusFilter;
